import api from '../../../dependencies/utils/Api';

import {
    DOWNLOAD_INCOMPLETE_REPORT,
} from '../../../constants/ApplicationUrl';

export const startupRecognitionReportService = {

    downloadReport(params) {
        return api.DOWNLOADDATA(`${DOWNLOAD_INCOMPLETE_REPORT}`,params).
            then((data) => {
                return data;
            }).catch(e => {
                return Promise.reject(e);
            })
    }
}